<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-lg-12">
          <div class="element-wrapper">
            <div class="element-box">
              <div>
                <h5 class="form-header">
                  Cotización &nbsp;
                  <span v-if="current.numero != null"
                    ># {{ current.numero }}</span
                  >
                  &nbsp;
                  <div
                    class="badge"
                    :class="{
                      'badge-success': current.estado == 'A',
                      'badge-warning': current.estado == 'B',
                      'badge-danger': current.estado == '9',
                    }"
                  >
                    <i class="os-icon os-icon-ui-09"></i>
                    <span v-if="current.estado_str">
                      {{ current.estado_str }}
                    </span>
                    <span v-if="!current.estado_str">En Proceso</span>
                  </div>

                  <div class="st-meta float-right">
                    <div class="element-actions">
                      <button
                        :disabled="current.estado == 'A'"
                        class="btn btn-outline-dark"
                        @click="imprimir"
                        type="button"
                      >
                        <i class="fa fa-print"></i>
                        Imprimir
                      </button>
                      &nbsp;
                      <button
                        type="button"
                        class="btn btn-md btn-success"
                        @click="autorizarTodo"
                        :disabled="
                          (current.sin_autorizar == 0 &&
                            current.estado == 'B') ||
                          current.estado != 'B'
                        "
                      >
                        <i class="fa fa-check-double"></i>
                        Autorizar Todo
                      </button>
                      &nbsp;
                      <div class="btn-group">
                        <button
                          aria-expanded="false"
                          aria-haspopup="true"
                          class="btn btn-secondary dropdown-toggle"
                          data-toggle="dropdown"
                          type="button"
                        >
                          <i class="fa fa-cogs"></i>
                          Acciones
                        </button>
                        <div class="dropdown-menu dropdown-menu-right">
                          <button
                            class="dropdown-item"
                            :class="{ disabled: !(current.estado == 'B') }"
                            @click="abrir"
                            :disabled="!(current.estado == 'B')"
                            href="#"
                            type="button"
                          >
                            <i class="fa fa-unlock"></i>
                            Abrir Operación
                          </button>
                          <button
                            class="dropdown-item"
                            @click="cerrar"
                            :disabled="!(current.estado == 'A')"
                            href="#"
                            type="button"
                          >
                            <i class="fa fa-lock"></i>
                            Cerrar Operación
                          </button>
                          <button
                            type="button"
                            class="dropdown-item"
                            @click="anular"
                            :disabled="!(current.estado != '9')"
                            href="#"
                          >
                            <i class="fa fa-archive"></i>
                            Anular Operación
                          </button>
                          <div class="dropdown-divider"></div>
                          <button
                            type="button"
                            class="dropdown-item"
                            :disabled="current.estado != 'B'"
                            href="#"
                            @click="generar_orden_compra"
                          >
                            <i class="fa fa-paper-plane"></i>
                            Generar Orden de Compra
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </h5>
                <small
                  v-if="current.errors && current.errors.detail"
                  class="form-text text-danger"
                  >{{ current.errors.detail }}</small
                >
                <div class="row">
                  <div class="col-sm-3">
                    <TiendaSelectComponent :current="current" />
                  </div>
                  <div class="col-sm-4">
                    <ProveedoresSelectComponent
                      v-on:keyup.enter="guardar"
                      :current="current"
                      :disabled="current.estado != 'A'"
                    />
                  </div>
                  <div class="col-sm-2">
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger':
                            current.errors.fecha &&
                            current.errors.fecha.length > 0,
                        }"
                        >Fecha</label
                      >
                      <input
                        class="form-control"
                        type="text"
                        :disabled="true"
                        v-model="current.fecha"
                      />
                      <small
                        v-if="current.errors && current.errors.fecha"
                        class="form-text text-danger"
                        >{{ current.errors.fecha[0] }}</small
                      >
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="form-group">
                      <label>Usuario</label>
                      <input
                        :disabled="true"
                        class="form-control"
                        v-model="current.usuario"
                        type="text"
                      />
                    </div>
                  </div>
                </div>

                <div class="invoice-table" v-if="current.id != null">
                  <table class="table table-striped table-hover">
                    <thead>
                      <tr>
                        <th style="width: 500px !important">Producto</th>
                        <th class="text-center">UM</th>
                        <th class="text-right" style="width: 250px !important">
                          Cantidad UM
                          <small
                            v-if="current.errors && current.errors.cantidad_um"
                            class="form-text text-danger"
                            >{{ current.errors.cantidad_um }}</small
                          >
                        </th>
                        <th class="text-right" style="width: 400px !important">
                          costo
                          <small
                            v-if="
                              current.errors && current.errors.precio_unitario
                            "
                            class="form-text text-danger"
                            >{{ current.errors.precio_unitario }}</small
                          >
                        </th>
                        <th class="text-right" style="width: 250px !important">
                          % de Descuento
                          <small
                            v-if="
                              current.errors && current.errors.precio_unitario
                            "
                            class="form-text text-danger"
                            >{{ current.errors.precio_unitario }}</small
                          >
                        </th>
                        <th lass="text-right" style="width: 400px !important">
                          Precio compra
                          <small
                            v-if="
                              current.errors && current.errors.precio_unitario
                            "
                            class="form-text text-danger"
                            >{{ current.errors.precio_unitario }}</small
                          >
                        </th>
                        <th class="text-right" style="width: 150px !important">
                          Precio sin impuesto
                          <small
                            v-if="
                              current.errors && current.errors.precio_unitario
                            "
                            class="form-text text-danger"
                            >{{ current.errors.precio_unitario }}</small
                          >
                        </th>
                        <th class="text-right">Impuesto</th>
                        <th class="text-right">Total</th>
                        <th
                          class="text-center"
                          v-if="current.estado != 'A'"
                          style="width: 200px !important"
                        >
                          Aut
                        </th>
                        <th class="text-center" v-if="current.estado != 'A'">
                          Linea
                        </th>
                        <th class="text-center"></th>
                        <th class="text-center"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(
                          detalle, indexDetalle
                        ) in current.cotizaciond_set"
                        :key="indexDetalle"
                      >
                        <td>
                          {{ detalle.producto.sku }}
                          <br />
                          <small>{{ detalle.producto.nombre }}</small>
                        </td>
                        <td class="text-center">
                          <span v-if="detalle.unidad_medida">{{
                            detalle.unidad_medida.nombre
                          }}</span>
                          <span v-if="!detalle.unidad_medida">Unidad</span>
                        </td>

                        <td class="text-right">
                          <span v-if="current.estado != 'A'">{{
                            detalle.cantidad_um
                          }}</span>
                          <div
                            class="input-group input-group-sm"
                            v-if="current.estado == 'A'"
                          >
                            <div class="input-group-prepend"></div>
                            <input
                              @change="calcularDetalle(indexDetalle)"
                              :disabled="current.estado == 'B'"
                              class="form-control text-right"
                              v-model="detalle.cantidad_um"
                              placeholder="Precio"
                              type="text"
                            />
                            <div class="input-group-append"></div>
                          </div>
                        </td>
                        <td class="text-right">
                          <span v-if="current.estado != 'A'">{{
                            detalle.costo
                          }}</span>
                          <div
                            class="input-group input-group-sm"
                            v-if="current.estado == 'A'"
                          >
                            <div class="input-group-prepend">
                              <div class="input-group-text">Q</div>
                            </div>
                            <input
                              @change="calcularDetalle(indexDetalle)"
                              :disabled="current.estado == 'B'"
                              class="form-control text-right"
                              v-model="detalle.costo"
                              placeholder="Precio"
                              type="text"
                            />
                            <div class="input-group-append"></div>
                          </div>
                        </td>
                        <td class="text-right">
                          <span v-if="current.estado != 'A'">{{
                            detalle.porc_descuento
                          }}</span>
                          <div
                            class="input-group input-group-sm"
                            v-if="current.estado == 'A'"
                          >
                            <div class="input-group-prepend">
                              <div class="input-group-text">%</div>
                            </div>
                            <input
                              @change="calcularPorsec(indexDetalle)"
                              :disabled="current.estado == 'B'"
                              class="form-control text-right"
                              v-model="detalle.porc_descuento"
                              placeholder="Precio"
                              type="text"
                            />
                            <div class="input-group-append"></div>
                          </div>
                        </td>
                        <td class="text-right">
                          <span v-if="current.estado != 'A'">{{
                            detalle.precio_unitario
                          }}</span>
                          <div
                            class="input-group input-group-sm"
                            v-if="current.estado == 'A'"
                          >
                            <div class="input-group-prepend">
                              <div class="input-group-text">Q</div>
                            </div>
                            <input
                              @change="calcularDetalle(indexDetalle)"
                              :disabled="current.estado == 'B'"
                              class="form-control text-right"
                              v-model="detalle.precio_unitario"
                              placeholder="Precio"
                              type="text"
                            />
                          </div>
                        </td>
                        <td class="text-right">
                          {{ detalle.precio_unitario_sin_imp }}
                        </td>
                        <td class="text-right">{{ detalle.tipo_impuesto }}</td>
                        <td class="text-right">Q{{ detalle.total_linea }}</td>
                        <td v-if="current.estado != 'A'" class="text-center">
                          <div
                            class="badge"
                            :class="{
                              'badge-success': current.autorizado,
                              'badge-warning': !current.autorizado,
                            }"
                          >
                            <span v-if="detalle.autorizado">
                              <i class="far fa-check-square"></i>
                            </span>
                            <span v-if="!detalle.autorizado">
                              <i class="far fa-square"></i>
                            </span>
                          </div>
                        </td>
                        <td class="text-center">
                          <span
                            v-if="detalle.estado == 'A'"
                            class="status-pill green"
                          ></span>
                          <span
                            v-if="detalle.estado == 'B'"
                            class="status-pill yellow"
                          ></span>
                          <span
                            v-if="detalle.estado == '9'"
                            class="status-pill red"
                          ></span>
                        </td>
                        <td class="text-center" style="width: 320px">
                          <button
                            class="btn btn-sm btn-success mr-1"
                            type="button"
                            @click="autorizarLinea(detalle)"
                            v-if="!detalle.autorizado "
                          >
                            <i class="fa fa-check"></i>
                            Aut
                          </button>
                          <button
                            v-if="current.estado == 'A'"
                            class="btn btn-success btn-sm"
                            @click="modificarLineaEnTabla(detalle)"
                          >
                            <i class="os-icon os-icon-save"></i>
                          </button>
                          <button
                            class="btn btn-sm btn-danger"
                            type="button"
                            @click="deleteDetalle(detalle)"
                            v-if="current.estado == 'A'"
                          >
                            <i class="fa fa-trash"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colspan="5">Total Detalle Cotización</td>
                        <td class="text-right" colspan="5">
                          Q {{ current.valor_total_cotizacion }}
                        </td>
                        <td colspan="3"></td>
                      </tr>
                    </tfoot>
                  </table>
                  <div class>
                    <button
                      type="button"
                      class="btn btn-sm btn-dark btn-block"
                      @click="showModalAddDetail"
                      v-if="current.estado == 'A'"
                    >
                      <i class="fa fa-plus"></i>
                      Agregar Producto
                    </button>
                  </div>
                  <!-------------------- END - Basic Table -------------------->
                </div>
                <div class="form-buttons-w">
                  <button
                    class="btn btn-md btn-primary"
                    v-if="current.estado == 'A'"
                    @click="guardar"
                  >
                    Guardar
                  </button>
                  <router-link
                    class="btn btn-outline-info"
                    :to="{ name: 'compras-cotizaciones' }"
                  >
                    <i class="fa fa-arrow-left"></i>
                    Listado de Cotizaciones
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      aria-hidden="true"
      class="onboarding-modal modal fade animated"
      id="modalAddDetailCotizacion"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content text-center">
          <button
            aria-label="Close"
            class="close"
            data-dismiss="modal"
            type="button"
          >
            <span class="close-label">Cerrar</span
            ><span class="os-icon os-icon-close"></span>
          </button>
          <div class="onboarding-content with-gradient">
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <label
                    v-bind:class="{
                      'text-danger':
                        currentDetalle.errors &&
                        currentDetalle.errors.length > 0,
                    }"
                  ></label>
                  <ProductoSelectComponentV2
                    @onChangeProducto="onChangeProducto"
                    :current="currentDetalle"
                  ></ProductoSelectComponentV2>
                  <small
                    v-if="currentDetalle.errors"
                    class="form-text text-danger"
                    >{{ currentDetalle.errors.detail }}</small
                  >
                </div>
              </div>
              <div class="col-sm-12">
                <div class="form-group">
                  <label
                    v-bind:class="{
                      'text-danger':
                        currentDetalle.errors &&
                        currentDetalle.errors.length > 0,
                    }"
                  ></label>
                  <UnidadMedidaSelectComponent
                    @onchangeselect="changeUnidadMedida"
                    :current="currentDetalle"
                  ></UnidadMedidaSelectComponent>
                  <small
                    v-if="unidades_medidas"
                    class="form-text text-danger"
                    >{{ unidades_medidas }}</small
                  >
                </div>
              </div>
              <div class="col-6 modal-header">
                <a
                  @change="calcularDetalle"
                  class="el-tablo centered trend-in-corner"
                >
                  <div class="label">Cantidad</div>
                  <div>
                    <input
                      class="form-control value"
                      style="
                        font-size: 32px;
                        text-align: center;
                        width: 100%;
                        height: 50px;
                      "
                      placeholder="Cantidad"
                      v-model="currentDetalle.cantidad_um"
                    />
                  </div>
                </a>
              </div>
              <div class="col-6 modal-header">
                <a
                  @change="calcularDetalle"
                  class="el-tablo centered trend-in-corner"
                >
                  <div class="label">Costo</div>
                  <div>
                    <input
                      class="form-control value"
                      style="text-align: center; width: 100%; height: 50px"
                      placeholder="Q"
                      v-model="currentDetalle.costo"
                    />
                  </div>
                  <small class="form-text text-success">Precio con IVA</small>
                </a>
              </div>
              <div class="col-6 modal-header">
                <a
                  @change="calcularPorsec"
                  class="el-tablo centered trend-in-corner"
                >
                  <div class="label">% descuento</div>
                  <div>
                    <input
                      class="form-control value"
                      style="text-align: center; height: 50px; width: 100%"
                      placeholder="%"
                      v-model="currentDetalle.porc_descuento"
                    />
                  </div>
                </a>
              </div>
              <div class="col-6 modal-header">
                <a
                  @change="calcularDetalle"
                  class="el-tablo centered trend-in-corner"
                >
                  <div class="label">Precio Compra</div>
                  <div>
                    <input
                      class="form-control value"
                      style="text-align: center; height: 50px; width: 100%"
                      placeholder="Q"
                      v-model="currentDetalle.precio_unitario"
                    />
                  </div>
                  <small class="form-text text-success">Precio con IVA</small>
                </a>
              </div>
              &nbsp;
              <div class="project-info col-12">
                <div class="row align-items-center">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-4">
                        <div class="el-tablo highlight text-center">
                          <div class="label">Costo Unitario</div>
                          <div class="value">
                            <h3 style="color: rgb(58, 180, 29)">
                              {{ currentDetalle.costo_unitario }}
                            </h3>
                          </div>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="el-tablo highlight text-center">
                          <div class="label">Precio sin IVA</div>
                          <div class="value">
                            <h3 style="color: rgb(58, 180, 29)">
                              {{ currentDetalle.precio_unitario_sin_imp }}
                            </h3>
                          </div>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="el-tablo highlight text-center">
                          <div class="label">Total</div>
                          <div class="value">
                            <h3 style="color: rgb(58, 180, 29)">
                              {{ currentDetalle.total_um }}
                            </h3>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-primary"
              @click="agregaDetalle"
              type="button"
            >
              Agregar
            </button>
            <button
              class="btn btn-secondary"
              ref="cerrarModal"
              data-dismiss="modal"
              type="button"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      aria-hidden="true"
      class="modal fade"
      id="modalModDetailCotizacion"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header faded smaller">
            <h5 class="modal-title">Modificar Producto</h5>
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div>
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger':
                          currentDetalle.errors &&
                          currentDetalle.errors.length > 0,
                      }"
                    ></label>
                    <ProductoSelectComponentV2
                      @onChangeProducto="onChangeProducto"
                      :current="currentDetalle"
                    ></ProductoSelectComponentV2>
                    <small
                      v-if="currentDetalle.errors"
                      class="form-text text-danger"
                      >{{ currentDetalle.errors.detail }}</small
                    >
                  </div>
                </div>
                <div class="col-sm-12">
                  <ProductoUnidadMedidaSelectComponent
                    :current="currentDetalle.producto"
                  />
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger':
                          currentDetalle.errors.cantidad_um &&
                          currentDetalle.errors.cantidad_um.length > 0,
                      }"
                      >Cantidad</label
                    >
                    <input
                      v-model="currentDetalle.cantidad_um"
                      class="form-control"
                      placeholder="Cantidad"
                      type="text"
                      style="text-align: center; font-size: 200%"
                      v-bind:class="{
                        'is-invalid':
                          currentDetalle.errors.cantidad_um &&
                          currentDetalle.errors.cantidad_um.length > 0,
                      }"
                    />
                    <small
                      v-if="
                        currentDetalle.errors &&
                        currentDetalle.errors.cantidad_um
                      "
                      class="form-text text-danger"
                      >{{ currentDetalle.errors.cantidad_um }}</small
                    >
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label>Precio Unitario</label>
                    <input
                      v-model="currentDetalle.precio_unitario"
                      v-bind:class="{
                        'is-invalid':
                          currentDetalle.errors.precio_unitario &&
                          currentDetalle.errors.precio_unitario.length > 0,
                      }"
                      class="form-control"
                      placeholder="Precio Unitario"
                      type="text"
                      style="text-align: center; font-size: 200%"
                    />
                    <small
                      v-if="
                        currentDetalle.errors &&
                        currentDetalle.errors.precio_unitario
                      "
                      class="form-text text-danger"
                      >{{ currentDetalle.errors.precio_unitario }}</small
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-primary"
              @click="modificarDetalle"
              type="button"
            >
              Modificar
            </button>
            <button
              class="btn btn-secondary"
              ref="cerrarModal"
              data-dismiss="modal"
              type="button"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import _ from "lodash";
import ProveedoresSelectComponent from "@/components/commons/ProveedoresSelectComponent";
import CommonService from "@/services/commons/CommonService";
import TiendaService from "@/services/catalogos/TiendaService";
import ProveedorService from "@/services/catalogos/ProveedorService";
import ProductosService from "@/services/catalogos/ProductosService";
import CotizacionesService from "@/services/compras/CotizacionesService";
import Notifications from "@/notifications/notifications";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import ProductoSelectComponentV2 from "@/components/commons/ProductoSelectComponentV2";
import ProductoUnidadMedidaSelectComponent from "@/components/commons/ProductoUnidadMedidaSelectComponent";
import DynamicService from "@/services/commons/DynamicService";
import UnidadMedidaSelectComponent from "@/components/commons/UnidadMedidaSelectComponent";

export default {
  components: {
    TiendaSelectComponent,
    ProveedoresSelectComponent,
    ProductoSelectComponentV2,
    UnidadMedidaSelectComponent,
    ProductoUnidadMedidaSelectComponent,
  },
  data() {
    return {
      current: {
        id: null,
        tienda: "",
        fecha: "01/01/2019",
        estado: "A",
        errors: [],
        reqcomprad_set: [],
      },
      tiendas: [],
      proveedores: [],

      productos: [],
      options: [],

      currentDetalle: {
        costo: "",
        porc_descuento: "",
        precio_unitario: "",
        precio_unitario_sin_imp: "",
        total_um: 0,
        id: null,
        cantidad: 0,
        cantidad_um: 0,
        unidad_medida: null,
        proveedor: null,
        producto: {
          sku: null,
          unidad_medida: null,
          errors: [],
        },
        errors: [],
      },
      unidades_medidas: "",
    };
  },
  computed: {
    ...mapGetters({
      reqcomprasData: "reqcompras/reqs_compras",
    }),
  },
  mounted() {
    let self = this;
    TiendaService.fetch({
      activa: true,
      quitar_paginacion: true,
    }).then((res) => {
      self.tiendas = res.data;
      self.current.tienda = self.tiendas.codigo;
    });
    CommonService.fecha_actual().then((res) => {
      self.current.fecha = res.data.fecha_actual;
    });
    if (this.$route.params.id) {
      ProveedorService.fetch({
        page: 1,
      }).then((res) => {
        self.proveedores = res.data.results;
      });
      self.refreshCurrent();
    }
  },
  methods: {
    changeUnidadMedida() {
      let self = this;
      self.currentDetalle.precio_unitario = 0;
      self.currentDetalle.costo = 0;
      self.currentDetalle.porc_descuento = 0;
      self.currentDetalle.cantidad_um = 0;
      self.calcularDetalle();
      if (self.unidades_medidas) {
        self.unidades_medidas = null;
      }
    },
    calcularDetalle(index = -1) {
      let self = this;
      if (index >= 0) {
        self.refreshDetalleDefault();
        self.currentDetalle = Object.assign(
          self.currentDetalle,
          self.current.cotizaciond_set[index]
        );
        self.currentDetalle.producto = self.currentDetalle.producto;
        self.currentDetalle.unidad_medida =
          self.currentDetalle.unidad_medida.id;
      }
      if (!self.currentDetalle.cantidad_um) {
        self.currentDetalle.cantidad_um = 0;
      }
      if (!self.currentDetalle.porc_descuento) {
        self.currentDetalle.porc_descuento = 0;
      }
      DynamicService.postAction(
        "compras",
        "cotizacion",
        self.current.id,
        "calcular_detalle",
        {
          producto: self.currentDetalle.producto.sku,
          cantidad_um: self.currentDetalle.cantidad_um,
          precio_unitario: self.currentDetalle.precio_unitario,
          costo: self.currentDetalle.costo,
          porc_descuento: self.currentDetalle.porc_descuento,
          unidad_medida: self.currentDetalle.unidad_medida,
        }
      )
        .then((response) => {
          self.currentDetalle.errors = "";
          self.currentDetalle.costo_unitario = response.data.costo_unitario;
          self.currentDetalle.costo = response.data.costo;
          self.currentDetalle.precio_unitario = response.data.precio_unitario;
          self.currentDetalle.total_um = response.data.total_um;
          self.currentDetalle.precio_unitario_sin_imp =
            response.data.precio_unitario_sin_imp;
          self.currentDetalle.porc_descuento = response.data.porc_descuento;
          self.currentDetalle.cantidad_um = response.data.cantidad_um;

          if (index >= 0) {
            self.current.cotizaciond_set[index].precio_unitario =
              self.currentDetalle.precio_unitario;
            self.current.cotizaciond_set[index].costo =
              self.currentDetalle.costo;
            self.current.cotizaciond_set[index].precio_unitario_con_desc =
              self.currentDetalle.precio_unitario_con_desc;
            self.current.cotizaciond_set[index].total_um =
              self.currentDetalle.total_um;
            self.current.cotizaciond_set[index].total_linea =
              self.currentDetalle.total_um;
            self.current.cotizaciond_set[index].precio_unitario_sin_imp =
              self.currentDetalle.precio_unitario_sin_imp;
            self.current.cotizaciond_set[index].porc_descuento =
              self.currentDetalle.porc_descuento;
            self.current.cotizaciond_set[index].cantidad_um =
              self.currentDetalle.cantidad_um;
          }
        })
        .catch((error) => {
          if (error.response) {
            self.currentDetalle.errors = error.response.data;
          }
        });
    },
    calcularPorsec(index = -1) {
      let self = this;
      if (index >= 0) {
        self.current.cotizaciond_set[index].precio_unitario = 0;
        self.refreshDetalleDefault();
        self.currentDetalle = Object.assign(
          self.currentDetalle,
          self.current.cotizaciond_set[index]
        );
        self.currentDetalle.producto = self.currentDetalle.producto_obj;
      }
      self.currentDetalle.precio_unitario = 0;
      self.calcularDetalle(index);
    },

    formatoFecha() {
      let self = this;
      self.current.fecha = self.current.fecha.replace(/\//g, "-");
    },
    refreshCurrent() {
      let self = this;
      CotizacionesService.getById(this.$route.params.id).then((response) => {
        self.current = response.data;
        self.current.usuario = response.data.usuario.name;
        self.current.tienda = response.data.tienda.codigo;
        self.current.fecha = self.current.fecha;
        self.current.errors = [];
        self.currentDetalle.errors = [];
        self.currentDetalle.cantidad = 0;
      });
    },
    guardar(e) {
      e.preventDefault();
      let self = this;
      let current = Object.assign({}, self.current);
      current.proveedor = self.current.proveedor.id;
      current.tienda = self.current.tienda;
      if (current.req_compra_e) {
        current.req_compra_e = current.req_compra_e.id;
      }
      CotizacionesService.save(current)
        .then((response) => {
          if (current.id == null) {
            self.$router.push({
              name: "compras-cotizaciones-editar",
              params: { id: response.data.id },
            });
            self.refreshCurrent();
          }
        })
        .catch((error) => {
          self.current.errors = error.response.data;
        });
    },

    onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },

    search: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      let that = this;
      ProveedorService.fetch({
        page: 1,
        quitar_paginacion: true,
        "filter[search]": search,
      }).then((res) => {
        vm.proveedores = res.data;
        loading(false);
      });
    }, 350),
    showModalAddDetail() {
      let self = this;
      ProductosService.fetch({
        page: 1,
        activo: true,
        permitir_compra: true,
      }).then((res) => {
        self.productos = res.data.results;
        $("#modalAddDetailCotizacion").modal();
      });
      self.refreshDetalleDefault();
    },

    showModalModDetail(detalle) {
      let self = this;
      self.currentDetalle = { ...self.currentDetalle, ...detalle };
      self.currentDetalle.producto.unidad_medida = detalle.unidad_medida.id;
      self.refreshUnidadMedida(detalle.producto);
      $("#modalModDetailCotizacion").modal();
    },
    modificarLineaEnTabla(detalle) {
      let self = this;
      self.currentDetalle = { ...self.currentDetalle, ...detalle };
      self.currentDetalle.producto.unidad_medida = detalle.unidad_medida.id;
      self.refreshUnidadMedida(detalle.producto);
      self.modificarDetalle();
    },
    modificarDetalle() {
      let self = this;
      let detMod = Object.assign({}, self.currentDetalle);
      if (detMod.producto) {
        detMod.producto = detMod.producto.sku;
      }
      detMod.unidad_medida = self.currentDetalle.producto.unidad_medida;

      CotizacionesService.modificar_detalle(self.current.id, detMod)
        .then((response) => {
          Notifications.alert.success(
            "Cotización",
            "Se ha Modificado la Información."
          );
          self.refreshCurrent();
          self.$refs.cerrarModal.click();
        })
        // "validaciones para los errores de modificacion de detalle cotizaciones a proveedores" //
        .catch((error) => {
          self.current.errors = error.response.data;
          if (error.response.data.detail) {
            Notifications.alert.error(
              "No se ha podido realizar la acción",
              error.response.data.detail
            );
          }
          if (error.response.data.precio_unitario_sin_imp) {
            Notifications.alert.error(
              "No se ha podido realizar la acción",
              "Falta colocar los precios"
            );
          }
        });
    },

    agregaDetalle(e) {
      e.preventDefault();
      let self = this;
      let det = Object.assign({}, self.currentDetalle);
      if (det.producto) {
        det.producto = det.producto.sku;
      }
      det.unidad_medida = self.currentDetalle.unidad_medida;
      CotizacionesService.addDetail(self.current.id, det)
        .then((response) => {
          Notifications.alert.success(
            "Cotización",
            "Se ha guardado la Información."
          );
          self.refreshDetalleDefault();
          self.refreshCurrent();
          self.precio_unitario = 0;
          $("#modalAddDetailCotizacion").modal("hide");
        })
        .catch((error) => {
          self.currentDetalle.errors = error.response.data;
          Notifications.alert.error(
            "Agregar Producto",
            error.response.data.detail
          );
        });
    },

    deleteDetalle(detalle) {
      let self = this;
      Notifications.alert.confirm(
        "Cotización",
        "¿Esta seguro de eliminar el registro?",
        "Si Eliminar",
        function () {
          CotizacionesService.deleteDetail(detalle.cotizacion_e, {
            id: detalle.id,
          })
            .then((response) => {
              Notifications.alert.success(
                "Cotización",
                "Se ha eliminado la Información."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              self.current.errors = error.response.data;
            });
        }
      );
    },
    abrir() {
      let self = this;
      Notifications.alert.confirm(
        "Cotización",
        "Desea Abrir la transacción?",
        "Si Abrir",
        function () {
          CotizacionesService.abrir(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Cotización",
                "Transaccion abierta puede continuar editando."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Abrir Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    cerrar() {
      let self = this;
      Notifications.alert.confirm(
        "Cotización",
        "Desea cerrar la transacción?",
        "Si Abrir",
        function () {
          CotizacionesService.cerrar(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Cotización",
                "Se ha cerrado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Cerrar Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    anular() {
      let self = this;
      Notifications.alert.confirm(
        "Cotización",
        "Desea Anular la transacción?",
        "Si Anular",
        function () {
          CotizacionesService.anular(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Cotización",
                "Se ha anulado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Anular Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    generar_orden_compra() {
      /**
       * Genera una orden de compra basada en la Cotizacion
       */
      let self = this;
      CotizacionesService.generar_orden_compra(self.current.id)
        .then((response) => {
          Notifications.alert.confirm(
            "Orden de Compra Generada",
            "Ir a la Orden de Compra Generada",
            "",
            function () {
              self.$router.push({
                name: "compras-ordencompra-editar",
                params: { id: response.data.orden_compra_e },
              });
            }
          );
        })
        .catch((error) => {
          Notifications.alert.error(
            "No se ha podido realizar la acción",
            error.response.data.detail
          );
        });
    },
    imprimir() {
      let self = this;
      CotizacionesService.pdf(self.current.id)
        .then((response) => {
          window.open(response.data.output);
        })
        .catch((error) => {
          Notifications.alert.error(
            "No se ha podido realizar la acción",
            error.response.data.detail
          );
        });
    },
    autorizarTodo() {
      let self = this;
      Notifications.alert.confirm(
        "Autorización de Cotización",
        "¿Desea autorizar TODAS las linea de la cotización para generar una Orden de Compra?",
        "Si",
        function () {
          CotizacionesService.autorizarTodo(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Autorización de Cotización",
                "Cotización Autorizada."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Autorización de Cotización",
                error.response.data.detail
              );
            });
        }
      );
    },
    autorizarLinea(detalle) {
      let self = this;
      Notifications.alert.confirm(
        "Autorización de Línea",
        "¿Desea autorizar la linea seleccionada para generar una Orden de Compra?",
        "Si",
        function () {
          CotizacionesService.autorizarLinea(self.current.id, {
            id: detalle.id,
          })
            .then((response) => {
              Notifications.alert.success(
                "Autorización de Línea",
                "Linea Autorizada."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Autorización de Línea",
                error.response.data.detail
              );
            });
        }
      );
    },
    onChangeProducto(producto) {
      let self = this;
      self.refreshUnidadMedida(producto);
    },
    refreshUnidadMedida(producto) {
      let self = this;
      DynamicService.getById("cat", "productos", producto.sku).then((res) => {
        if (res.data.unidad_medida_compra_obj) {
          self.currentDetalle.unidad_medida =
            res.data.unidad_medida_compra_obj.id;
          if (self.unidades_medidas) {
            delete self.unidades_medidas;
          }
        } else {
          self.unidades_medidas =
            "Producto no tiene asignado unidad medida para compra pero puede seleccionar una de la lista";
          self.currentDetalle.unidad_medida = "";
        }
        self.currentDetalle.precio_unitario = 0;
        self.currentDetalle.costo = 0;
        self.currentDetalle.porc_descuento = 0;
        self.currentDetalle.cantidad_um = 1;
        self.calcularDetalle();
      });
    },
    refreshDetalleDefault() {
      let self = this;
      self.currentDetalle = {
        cantidad: 1,
        precio_unitario: 0,
        precio_unitario_con_desc: 0,
        precio_unitario_sin_imp: 0,
        costo: 0,
        total_um: 0,
        cantidad_um: 0,
        unidad_medida: "",
        proveedor: null,
        producto: {
          sku: null,
          unidad_medida: null,
          errors: [],
        },
        errors: [],
      };
    },
  },
};
</script>
